import { AnchorButtonTemplate, ToggleButtonStyles } from "@fluentui/web-components";
import { DesignSystem } from "../design-system.js";
import { AnchorButton } from "./anchor-button.js";
/**
 * The Fabric Anchor Button component.
 *
 * @public
 */
export const definition = AnchorButton.compose({
    name: `${DesignSystem.prefix}-anchor-button`,
    template: AnchorButtonTemplate,
    styles: ToggleButtonStyles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=anchor-button.definition.js.map